import React from "react";
import { Row, Col, Typography, Breadcrumb, Button, Tag } from "antd";
import { Link } from "react-router-dom";
//import { MdSecurity } from "react-icons/md";
const { Title, Text } = Typography;
export default function PageTitle({ collectionDetails }) {
  return (
    <div>
      <Row>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/"> Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/catalogue-history"> All Catalogues</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Buyer Activity</Breadcrumb.Item>
        </Breadcrumb>
      </Row>
      <Row style={{ marginTop: "2em" }} justify="space-between" align="middle">
        <Col>
          <Row align="middle" justify="space-around">
            <Col>
              {" "}
              <Title level={3} style={{ marginBottom: 5 }}>
                Activity on {collectionDetails?.collection_name}
              </Title>
            </Col>
            <Col push={1}>
              <Tag
                //</Col>color={collectionDetails?.status === "published"?"#F3EFFD":"#E6E7E7"}
                style={{ borderRadius: "32em" }}
              >
                {" "}
                {collectionDetails?.status === "published"
                  ? "ACTIVE"
                  : collectionDetails?.status.toUpperCase()}{" "}
              </Tag>
            </Col>
          </Row>
          {/* <Row>
            <Text type="secondary"> Link expires in 3 days on DD/MM/YYYY</Text>
          </Row> */}
        </Col>
        {/* <Col>
          <Button className="link-setttings-btn">
            <Row align="middle" justify="space-around">
              <Col>
                <MdSecurity size={16} />
              </Col>
              <Col>Link Settings</Col>
            </Row>
          </Button>
        </Col> */}
      </Row>
    </div>
  );
}
